import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Icon_PhatP from '../resources/Footer_Icons/PHat-P.svg';
import {
  Email_Icon,
  Info_Icon,
  Instagram_Icon,
  Kununu_Icon,
  LinkedIn_Icon,
} from '../resources/Footer_Icons/Footer_Icons';
import LinkIconWrapper from './LinkIconWrapper';

// Footer of phatconsulting.de (without the logo, per People): dotted LED line, one list of links with round white icons.
const useStyles = makeStyles({
  footer: {
    color: '#fff',
    fontFamily: 'DIN2014-Regular, Helvetica, Arial, sans-serif',
    fontSize: '18px',
    lineHeight: 1.25,
    padding: '70px 16px 60px',
    display: 'flex',
    justifyContent: 'center',
  },
  column: {
    width: '100%',
    maxWidth: '520px',
  },
  headline: {
    fontFamily: 'LedRegular, Arial, sans-serif',
    fontSize: '29.25px',
    marginBottom: '16px',
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  inline: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px 20px',
  },
  about: {
    display: 'flex',
    gap: '10px',
    marginTop: '18px',
  },
});

const Footer = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Box className={classes.footer} component="footer">
      <div className={classes.column}>
        <Typography className={classes.headline}>Jetzt reden wir aber mal, oder?</Typography>
        <div className={classes.rows}>
          <LinkIconWrapper
            icon={Email_Icon}
            linkText="recruiting@phatconsulting.de"
            linkURL="mailto:recruiting@phatconsulting.de"
          />
          <div className={classes.inline}>
            <LinkIconWrapper
              icon={LinkedIn_Icon}
              linkText="LinkedIn"
              linkURL="https://de.linkedin.com/company/phat-consulting-gmbh"
            />
            <LinkIconWrapper
              icon={Instagram_Icon}
              linkText="Instagram"
              linkURL="https://www.instagram.com/phatconsulting/?hl=de"
            />
            <LinkIconWrapper
              icon={Kununu_Icon}
              linkText="Kununu"
              linkURL="https://www.kununu.com/de/phat-consulting2"
            />
          </div>
          <LinkIconWrapper
            icon={Info_Icon}
            linkText="Impressum"
            linkURL="https://www.phatconsulting.de/impressum/"
          />
          <LinkIconWrapper
            icon={null}
            linkText="Datenschutz"
            linkURL="https://www.phatconsulting.de/datenschutz/"
          />
          <LinkIconWrapper icon={null} linkText="phatconsulting.de" linkURL="https://www.phatconsulting.de/" />
        </div>
        <div className={classes.about}>
          <img alt="" src={Icon_PhatP} style={{ width: 20, height: 20, marginTop: 2 }} />
          <span>
            Seit über 25 Jahren erarbeiten wir gemeinsam mit unseren Kunden individuelle Lösungen, um die
            Herausforderungen der IT und der Digitalisierung zu meistern.
          </span>
        </div>
      </div>
    </Box>
  );
};

export default Footer;
